export default "/packs/a949e862cb8086c9dfa3e05e896962ae.svg";